import {
  call, getContext, put, takeLatest,
} from 'redux-saga/effects';

import EventualWeatherActions, { EventualWeatherTypes } from 'reducers/eventualWeather';
import ProfileActions from 'reducers/profile';
import EventualWeatherApi from 'apis/supremeGolfApi/EventualWeatherApi';

const INSURANCE_TIMEOUT = 408;
export function* getEventualInsuranceDetails({ courseId, quoteParams }) {
  try {
    const data = yield call(EventualWeatherApi.getEventualInsuranceDetails, courseId);
    yield put(EventualWeatherActions.getEventualInsuranceDetailsDone(data));
    const { reservationId, accessToken } = quoteParams || {};
    if (reservationId) {
      yield put(EventualWeatherActions.getInsuranceQuote(reservationId, accessToken));
    }
  } catch (error) {
    const errorMessage = error?.message || error?.response?.data?.error;
    yield put(EventualWeatherActions.getEventualInsuranceDetailsError(errorMessage));
  }
}

export function* getInsuranceQuote({ reservationId, accessToken = '' }) {
  try {
    const LS = yield getContext('localStorage');
    const utmParams = yield call(LS.getUtmParams);
    const iterable = yield getContext('iterable');
    const iterableTracking = yield call(iterable.getTrackingParams, true);

    const data = yield call(
      EventualWeatherApi.getEventualInsuranceQuote,
      reservationId,
      accessToken,
      { iterableTracking, utmParams },
    );
    if (data?.creditCard) yield put(EventualWeatherActions.setInsuranceCreditCard(data.creditCard));
    yield put(EventualWeatherActions.getInsuranceQuoteDone(data.quote));
  } catch (error) {
    const errorMessage = error?.response?.data?.error || error?.message;
    const timeout = error?.response?.status === INSURANCE_TIMEOUT;
    if (timeout) {
      yield put(EventualWeatherActions.getInsuranceQuoteDone(error?.response?.data?.quote || {}));
    }
    yield put(EventualWeatherActions.getInsuranceQuoteError(errorMessage, timeout));
  }
}

export function* purchaseEventualInsurance({ reservationId, params }) {
  try {
    const data = yield call(EventualWeatherApi.purchaseEventualInsurance, reservationId, params);
    const status = data?.success ? 'success' : 'failure';
    yield put(ProfileActions.getProfile());
    yield put(EventualWeatherActions.purchaseEventualInsuranceDone(status));
  } catch (error) {
    const errorMessage = error?.message || error?.response?.data?.error;
    yield put(EventualWeatherActions.purchaseEventualInsuranceError(errorMessage));
  }
}

function* getEventualInsuranceDetailsWatcher() {
  yield takeLatest(
    EventualWeatherTypes.GET_EVENTUAL_INSURANCE_DETAILS,
    getEventualInsuranceDetails,
  );
}

function* getInsuranceQuoteWatcher() {
  yield takeLatest(EventualWeatherTypes.GET_INSURANCE_QUOTE, getInsuranceQuote);
}

function* purchaseEventualInsuranceWatcher() {
  yield takeLatest(EventualWeatherTypes.PURCHASE_EVENTUAL_INSURANCE, purchaseEventualInsurance);
}

export default [
  getEventualInsuranceDetailsWatcher,
  getInsuranceQuoteWatcher,
  purchaseEventualInsuranceWatcher,
];
